import { Box, Typography } from "@mui/material";
import DialogComponent from "../../../../../components/dialog-component/dialog-component";
import { DetailedBlockOffModalStyled } from "./detail-blockoff-modal.styles";
import OverflowText from "../../../../../components/overflow-text/overflow-text";
import { convertTo12HourFormat } from "../blockoffs.utils";

const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};

const DetailBlockOffModal = ({ item, onClose }: any) => {
  console.log({ item });

  if (!item) return null;
  return (
    <DialogComponent
      open
      title="View Blockoff"
      content={
        <DetailedBlockOffModalStyled>
          <Box display="flex" flexDirection="column" gap={2}>
            <Box>
              <Typography variant="subtitle2">Reason:</Typography>
              <Typography variant="body2" fontWeight="bold">
                {item.reason || "N/A"}
              </Typography>
            </Box>
            <Box>
              <Typography variant="subtitle2">Blockoff Range:</Typography>
              <span
                style={{ display: "flex", gap: "16px", alignItems: "center" }}
              >
                <Typography variant="body2" fontWeight="bold">
                  {formatDate(item.start_date)}
                </Typography>
                to
                <Typography variant="body2" fontWeight="bold">
                  {formatDate(item.end_date)}
                </Typography>
              </span>
            </Box>
            <Box>
              <Typography variant="subtitle2">Date:</Typography>
              <Typography variant="body2" fontWeight="bold">
                {item.label || "N/A"}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "auto auto",
              }}
            >
              <Box>
                <Typography variant="subtitle2">Start Time:</Typography>
                <Typography variant="body2" fontWeight="bold">
                  {convertTo12HourFormat(item.start_time) || "N/A"}
                </Typography>
              </Box>
              <Box>
                <Typography variant="subtitle2">End Time:</Typography>
                <Typography variant="body2" fontWeight="bold">
                  {convertTo12HourFormat(item.end_time) || "N/A"}
                </Typography>
              </Box>
            </Box>
            <Box>
              <Typography variant="subtitle2">Repeat Interval:</Typography>
              <Typography variant="body2" fontWeight="bold">
                {item.repeat_interval || "Single Day"}
              </Typography>
            </Box>
            {item.repeat_exceptions && item.repeat_exceptions.length > 0 && (
              <Box>
                <Typography variant="subtitle2">Exceptions:</Typography>
                <OverflowText  className="repeat-interval">
                  {item.repeat_exceptions
                    ?.map((x: string) => formatDate(x))
                    .join(", ") || "No exceptions"}
                </OverflowText>
              </Box>
            )}
          </Box>
        </DetailedBlockOffModalStyled>
      }
      onClose={onClose}
    />
  );
};
export default DetailBlockOffModal;
